var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
import { useDependencyList } from '../useDependencyList/useDependencyList';
export const useUpdateOnly = (callback, dependencyList, comparator) => {
    _react_refresh_temp_1();
    const initialDependencyListRef = useRef(dependencyList);
    const dependencies = useDependencyList(dependencyList, comparator);
    useEffect(() => {
        if (initialDependencyListRef.current === dependencies) {
            return;
        }
        const result = callback();
        return () => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional
            (async () => {
                const func = await result;
                if (typeof func === 'function') {
                    // eslint-disable-next-line @typescript-eslint/await-thenable -- Intentional
                    await func();
                }
            })();
        };
    }, dependencies);
};
_react_refresh_temp_1(useUpdateOnly, "HjZYNeeXp0uFVZRCQqyINIfo33U=", false, () => [useDependencyList]);
